import React, { useState } from 'react';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { Modal } from '../../../components/Modal';

interface AddManualUserModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAdd: (name: string) => Promise<void>;
}

export const AddManualUserModal: React.FC<AddManualUserModalProps> = ({
    isOpen,
    onClose,
    onAdd
}) => {
    const [name, setName] = useState('');

    const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (name.trim()) {
            await onAdd(name);
            setName('');
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Add Manual User">
            <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                    label="User Name"
                    placeholder="e.g. John Doe"
                    value={name}
                    onChange={(e) => { setName(e.target.value); }}
                    autoFocus={isOpen} // Only autofocus when open
                />
                <p className="text-xs text-text-muted">
                    Manual users are temporary and only exist within this tab for accounting purposes.
                </p>
                <Button type="submit" className="w-full h-12">Add User</Button>
            </form>
        </Modal>
    );
};
